import { connect, useSelector } from "react-redux";
import { createQuestions, updateQuestions } from "../store/action";
import {
  CreateQuestionInput,
  OptionInput,
  QuationProps,
  QuestionInput,
  stateStatusType,
  UpdateQuestionInput,
} from "../store/actionType";
import QuestionForm from "./components/QuestionForm";
import { FormEvent, useEffect, useState } from "react";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";

interface OwnProps {
  questionData: QuationProps[];
  videoData: VideoDetailProps;
  questionId: string;
   onClose: () => void;
   setMode: (mode: "add" | "preview") => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateQuestion: React.FC<Props> = ({
  onUpdateQuestion,
  questionData,
  videoData,
  questionId,
  onClose,
  setMode
}) => {
  const [submitted, setSubmitted] = useState(false);
  const [questions, setQuestions] = useState<QuestionInput[]>(
    questionData || []
  );
  const [apiError, setApiError] = useState<string | null>(null);
  const [isValid, setIsValid] = useState(false);
  const questionState = useSelector(
    (state: any) => state.questions?.genericQuestionsState
  );
  const handleChange = (qs: QuestionInput[], valid: boolean) => {
    setQuestions(qs);
    setIsValid(valid);
  };
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!isValid || questions.length === 0) {
      setApiError("Please fill all required fields correctly.");
      return;
    }

    setSubmitted(true);

    if (isValid && questions.length !== 0) {
      const { question, is_published, options } = questions[0];
      const mappedOptions: OptionInput[] = options.map((opt) => ({
        option: opt.option,
        is_correct_answer: opt.is_correct_answer,
      }));
      const input: UpdateQuestionInput = {
        video_id: videoData.id.toString(),
        question,
        is_published,
        options: mappedOptions,
      };
      onUpdateQuestion(questionId.toString(), input);
    }
  };

  useEffect(() => {
    if (!submitted) return;

    if (questionState.isLoading) return;

    if (questionState.status === stateStatusType.SUCCESS) {
      setApiError(null);
      onClose()
      setMode("preview")
    }

    if (questionState.status === stateStatusType.FAILED) {
      setApiError(questionState.error || "Failed to create questions.");
    }

    setSubmitted(false);
  }, [questionState, submitted]);
  return (
    <>
      <QuestionForm
        initialQuestions={questionData}
        onChange={handleChange}
        handleSubmit={handleSubmit}
        isUpdateMode
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateQuestion: (questionId: string, input: UpdateQuestionInput) =>
    dispatch(updateQuestions(questionId, input)),
});

export default connect(null, mapDispatchToProps)(HandleUpdateQuestion);
